import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router";
import UsersList from "./components/UsersList";
import Home from "./pages/Home";
import MainContent from "./components/MainContent";
import Contact from "./pages/Contact";
import ErrorPage from "./pages/ErrorPage";

const el = document.getElementById("root");
const root = ReactDOM.createRoot(el);
root.render(
  <Provider store={store}>
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="gallery" element={<UsersList></UsersList>}></Route>
          <Route path="home" element={<Home></Home>}>
            <Route path="contact" element={<Contact></Contact>}></Route>
          </Route>
        </Route>
        <Route path="/:anything" element={<ErrorPage></ErrorPage>}></Route>
      </Routes>
    </BrowserRouter>
  </Provider>
);
